// ============================================================
// DOCTORS — DEMO / PLACEHOLDER DATA
// Every profile below is sample content (isDemo: true).
// Replace names, qualifications, photos and schedules with the
// hospital's real doctor information. Add/remove entries freely —
// the listing and profile pages update automatically.
// ============================================================

export const DOCTORS = [
  {
    slug: "dr-rajesh-kumar-sahu",
    name: "Dr. Rajesh Kumar Sahu",
    qualifications: "MBBS, MD", // DEMO — replace with actual qualification
    designation: "Consultant Physician",
    specialty: "General Medicine",
    intro:
      "Provides primary and continuing medical care for adults, with a focus on careful diagnosis and clear guidance.",
    experience: "Demo value — update with the doctor's actual experience.",
    expertise: [
      "General consultations",
      "Fever and common infections",
      "Lifestyle-related conditions",
      "Preventive health guidance",
    ],
    location: "Kasdol Multispeciality Hospital, Kasdol",
    // DEMO schedule — replace with the doctor's actual consultation days/timings
    schedule: [
      { day: "Monday", time: "10:00 AM – 1:00 PM" },
      { day: "Wednesday", time: "4:00 PM – 7:00 PM" },
      { day: "Saturday", time: "10:00 AM – 1:00 PM" },
    ],
    image: "/images/doctor-rajesh-sahu.jpg",
    isDemo: true,
  },
  {
    slug: "dr-ananya-verma",
    name: "Dr. Ananya Verma",
    qualifications: "MBBS, DGO", // DEMO — replace with actual qualification
    designation: "Consultant, Women's Health",
    specialty: "Women's Health",
    intro:
      "Focuses on women's health across all life stages, with an emphasis on comfort, privacy and clear communication.",
    experience: "Demo value — update with the doctor's actual experience.",
    expertise: [
      "Women's health consultations",
      "Antenatal check-ups",
      "Menstrual health guidance",
      "Preventive screening advice",
    ],
    location: "Kasdol Multispeciality Hospital, Kasdol",
    // DEMO schedule — replace with the doctor's actual consultation days/timings
    schedule: [
      { day: "Tuesday", time: "10:00 AM – 1:00 PM" },
      { day: "Thursday", time: "4:00 PM – 7:00 PM" },
      { day: "Saturday", time: "4:00 PM – 7:00 PM" },
    ],
    image: "/images/doctor-ananya-verma.jpg",
    isDemo: true,
  },
  {
    slug: "dr-vikram-singh",
    name: "Dr. Vikram Singh",
    qualifications: "MBBS, DCH", // DEMO — replace with actual qualification
    designation: "Child Health Specialist",
    specialty: "Child Healthcare",
    intro:
      "Cares for infants, children and adolescents, supporting parents with practical, reassuring medical advice.",
    experience: "Demo value — update with the doctor's actual experience.",
    expertise: [
      "Newborn and child check-ups",
      "Growth and nutrition guidance",
      "Common childhood illnesses",
      "Vaccination counselling",
    ],
    location: "Kasdol Multispeciality Hospital, Kasdol",
    // DEMO schedule — replace with the doctor's actual consultation days/timings
    schedule: [
      { day: "Monday", time: "4:00 PM – 7:00 PM" },
      { day: "Thursday", time: "10:00 AM – 1:00 PM" },
      { day: "Friday", time: "10:00 AM – 1:00 PM" },
    ],
    image: "/images/doctor-vikram-singh.jpg",
    isDemo: true,
  },
  {
    slug: "dr-priya-sharma",
    name: "Dr. Priya Sharma",
    qualifications: "MBBS", // DEMO — replace with actual qualification
    designation: "Family Medicine Consultant",
    specialty: "Family Healthcare",
    intro:
      "Looks after the everyday health needs of individuals and families, from routine check-ups to ongoing care.",
    experience: "Demo value — update with the doctor's actual experience.",
    expertise: [
      "Family health consultations",
      "General health check-ups",
      "Elderly care guidance",
      "Health education",
    ],
    location: "Kasdol Multispeciality Hospital, Kasdol",
    // DEMO schedule — replace with the doctor's actual consultation days/timings
    schedule: [
      { day: "Tuesday", time: "4:00 PM – 7:00 PM" },
      { day: "Wednesday", time: "10:00 AM – 1:00 PM" },
      { day: "Friday", time: "4:00 PM – 7:00 PM" },
    ],
    image: "/images/doctor-priya-sharma.jpg",
    isDemo: true,
  },
];

export const getDoctorBySlug = (slug) => DOCTORS.find((d) => d.slug === slug);
